import type { IServicesCollection } from 'src/packages/di';

import type { ISessionService } from './SessionService';
import { SessionService } from './SessionService';

declare module 'src/packages/di' {
  export interface ServicesCollectionMap {
    sessionService: ISessionService;
  }
}

export async function addSessionService(di: IServicesCollection): Promise<void> {
  const sessionService = new SessionService();

  di.addSingleton('sessionService', sessionService);
}
